/** Limits for HTML5 date inputs (`<input type="date">`). */
export const DATE_INPUT_MIN = '2000-01-01';

/** End of year, five years ahead — avoids hard-coding a year that blocks future planning. */
export const DATE_INPUT_MAX = `${new Date().getFullYear() + 5}-12-31`;
